import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  FaHeart,
  FaShieldAlt,
  FaComments,
  FaVideo,
  FaCheckCircle,
  FaUserFriends,
  FaLock,
  FaStar,
  FaPlayCircle,
  FaBroadcastTower,
  FaCoins,
  FaGift,
} from "react-icons/fa";

import logo from "../assets/logo.png";
import logo1 from "../assets/logo1.png";
import heroCouple from "../assets/couple.png";

const styles = `
  :root {
    --myhalal-primary: #ff5f91;
    --myhalal-primary-dark: #ea477d;
    --myhalal-secondary: #fff0f5;
    --myhalal-dark: #25182f;
    --myhalal-text: #5f5865;
    --myhalal-border: #f0e8ed;
    --myhalal-white: #ffffff;
  }

  * {
    box-sizing: border-box;
  }

  html {
    min-height: 100%;
    scroll-behavior: smooth;
  }

  html.landing-page-html,
  body.landing-page-body {
    width: 100%;
    min-height: 100%;
    height: auto !important;
    overflow-x: hidden !important;
    overflow-y: auto !important;
    position: static !important;
    overscroll-behavior-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  body.landing-page-body {
    margin: 0;
    padding: 0;
    background: white;
    touch-action: pan-y;
  }

  body.landing-page-body #root {
    width: 100%;
    min-height: 100%;
    height: auto !important;
    overflow: visible !important;
    position: static !important;
  }

  .landing-page {
    width: 100%;
    min-height: 100vh;
    min-height: 100dvh;
    overflow-x: clip;
    overflow-y: visible;
    background: white;
    color: var(--myhalal-dark);
    font-family: Arial, Helvetica, sans-serif;
    touch-action: pan-y;
  }

  .landing-container {
    width: min(1180px, calc(100% - 40px));
    margin: 0 auto;
  }

  .landing-header {
    position: sticky;
    top: 0;
    z-index: 1000;
    background: rgba(255, 255, 255, 0.96);
    border-bottom: 1px solid rgba(240, 232, 237, 0.9);
    backdrop-filter: blur(14px);
  }

  .navigation {
    min-height: 78px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 30px;
  }

  .landing-logo {
    display: flex;
    align-items: center;
  }

  .landing-logo img {
    width: auto;
    height: 58px;
    object-fit: contain;
  }

  .landing-nav {
    display: flex;
    align-items: center;
    gap: 35px;
  }

  .landing-nav a {
    color: var(--myhalal-dark);
    text-decoration: none;
    font-size: 15px;
    font-weight: 600;
    transition: color 0.25s ease;
  }

  .landing-nav a:hover {
    color: var(--myhalal-primary);
  }

  .navigation-actions {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .language-switcher {
    display: flex;
    align-items: center;
    padding: 3px;
    background: var(--myhalal-secondary);
    border-radius: 999px;
  }

  .language-switcher button {
    width: 38px;
    height: 34px;
    border: none;
    border-radius: 999px;
    background: transparent;
    color: var(--myhalal-text);
    font-size: 12px;
    font-weight: 800;
    cursor: pointer;
    transition: all 0.25s ease;
  }

  .language-switcher button.language-active {
    color: white;
    background: var(--myhalal-primary);
  }

  .bouton-login-header,
  .bouton-inscription-header {
    min-height: 44px;
    padding: 0 21px;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    font-weight: 700;
    font-size: 14px;
    transition: all 0.25s ease;
  }

  .bouton-login-header {
    color: var(--myhalal-primary);
    border: 1px solid var(--myhalal-primary);
    background: white;
  }

  .bouton-login-header:hover {
    background: var(--myhalal-secondary);
  }

  .bouton-inscription-header {
    color: white;
    background: var(--myhalal-primary);
    border: 1px solid var(--myhalal-primary);
    box-shadow: 0 8px 18px rgba(255, 95, 145, 0.25);
  }

  .bouton-inscription-header:hover {
    background: var(--myhalal-primary-dark);
    transform: translateY(-2px);
  }

  .hero-myhalal {
    position: relative;
    overflow: hidden;
    padding: 85px 0 90px;
    background:
      radial-gradient(
        circle at 90% 10%,
        rgba(255, 95, 145, 0.12),
        transparent 30%
      ),
      radial-gradient(
        circle at 5% 80%,
        rgba(255, 190, 210, 0.2),
        transparent 28%
      ),
      linear-gradient(180deg, #fff 0%, #fff8fb 100%);
  }

  .hero-contenu {
    display: grid;
    grid-template-columns: 1.05fr 0.95fr;
    align-items: center;
    gap: 70px;
  }

  .hero-texte {
    position: relative;
    z-index: 2;
  }

  .hero-badge {
    display: inline-flex;
    align-items: center;
    gap: 9px;
    padding: 9px 15px;
    color: var(--myhalal-primary-dark);
    background: var(--myhalal-secondary);
    border: 1px solid rgba(255, 95, 145, 0.18);
    border-radius: 999px;
    font-size: 14px;
    font-weight: 700;
  }

  .hero-texte h1 {
    max-width: 650px;
    margin: 24px 0 22px;
    font-size: clamp(44px, 5.2vw, 72px);
    line-height: 1.06;
    letter-spacing: -2.5px;
  }

  .hero-texte h1 span {
    color: var(--myhalal-primary);
  }

  .hero-description {
    max-width: 590px;
    margin: 0;
    color: var(--myhalal-text);
    font-size: 19px;
    line-height: 1.75;
  }

  .hero-actions {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 15px;
    margin-top: 34px;
  }

  .bouton-principal,
  .bouton-secondaire {
    min-height: 54px;
    padding: 0 27px;
    border-radius: 999px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    text-decoration: none;
    font-size: 15px;
    font-weight: 700;
    transition: all 0.25s ease;
  }

  .bouton-principal {
    color: white;
    background: var(--myhalal-primary);
    border: 1px solid var(--myhalal-primary);
    box-shadow: 0 14px 28px rgba(255, 95, 145, 0.28);
  }

  .bouton-principal:hover {
    background: var(--myhalal-primary-dark);
    transform: translateY(-3px);
  }

  .bouton-secondaire {
    color: var(--myhalal-dark);
    background: white;
    border: 1px solid var(--myhalal-border);
  }

  .bouton-secondaire:hover {
    color: var(--myhalal-primary);
    border-color: var(--myhalal-primary);
    transform: translateY(-2px);
  }

  .hero-garanties {
    display: flex;
    flex-wrap: wrap;
    gap: 17px;
    margin-top: 28px;
  }

  .hero-garanties span {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    color: var(--myhalal-text);
    font-size: 13px;
    font-weight: 600;
  }

  .hero-garanties svg {
    color: var(--myhalal-primary);
  }

  .hero-visuel {
    min-height: 565px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .hero-image-wrapper {
    width: min(440px, 88%);
    height: 540px;
    position: relative;
    overflow: hidden;
    border-radius: 220px 220px 40px 40px;
    background: linear-gradient(145deg, #ffe7ef, #fff);
    border: 10px solid white;
    box-shadow: 0 30px 70px rgba(74, 32, 54, 0.15);
    z-index: 2;
  }

  .hero-image {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }

  .cercle-decoration {
    position: absolute;
    border-radius: 50%;
  }

  .cercle-un {
    width: 360px;
    height: 360px;
    right: -70px;
    top: -15px;
    background: rgba(255, 95, 145, 0.09);
  }

  .cercle-deux {
    width: 180px;
    height: 180px;
    left: -25px;
    bottom: 20px;
    background: rgba(255, 177, 202, 0.17);
  }

  .carte-flottante {
    position: absolute;
    z-index: 4;
    min-width: 220px;
    padding: 16px;
    display: flex;
    align-items: center;
    gap: 13px;
    background: rgba(255, 255, 255, 0.96);
    border: 1px solid rgba(255, 95, 145, 0.12);
    border-radius: 17px;
    box-shadow: 0 18px 40px rgba(60, 31, 47, 0.14);
  }

  .carte-flottante > svg {
    flex-shrink: 0;
    padding: 11px;
    width: 44px;
    height: 44px;
    color: white;
    background: var(--myhalal-primary);
    border-radius: 14px;
  }

  .carte-flottante div {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .carte-flottante strong {
    color: var(--myhalal-dark);
    font-size: 14px;
  }

  .carte-flottante span {
    color: var(--myhalal-text);
    font-size: 12px;
  }

  .carte-profils {
    left: -15px;
    top: 95px;
  }

  .carte-securite {
    right: -20px;
    bottom: 80px;
  }

  .section-statistiques {
    padding: 25px 0;
    background: var(--myhalal-primary);
  }

  .statistiques-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
  }

  .statistique {
    padding: 25px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    color: white;
    border-right: 1px solid rgba(255, 255, 255, 0.25);
  }

  .statistique:last-child {
    border-right: 0;
  }

  .statistique strong {
    font-size: 27px;
    margin-bottom: 7px;
  }

  .statistique span {
    font-size: 14px;
    opacity: 0.9;
  }

  .section-fonctionnalites,
  .section-temoignages {
    padding: 100px 0;
  }

  .titre-section {
    max-width: 760px;
    margin: 0 auto 55px;
    text-align: center;
  }

  .titre-section > span,
  .petit-titre {
    color: var(--myhalal-primary);
    font-size: 14px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 1.4px;
  }

  .titre-section h2,
  .securite-texte h2 {
    margin: 15px 0;
    font-size: clamp(32px, 4vw, 48px);
    line-height: 1.16;
    letter-spacing: -1.5px;
  }

  .titre-section p,
  .securite-texte > p {
    color: var(--myhalal-text);
    font-size: 17px;
    line-height: 1.75;
  }

  .fonctionnalites-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
  }

  .carte-fonctionnalite {
    padding: 32px;
    background: white;
    border: 1px solid var(--myhalal-border);
    border-radius: 22px;
    box-shadow: 0 12px 35px rgba(55, 30, 44, 0.055);
    transition:
      transform 0.25s ease,
      box-shadow 0.25s ease;
  }

  .carte-fonctionnalite:hover {
    transform: translateY(-7px);
    box-shadow: 0 20px 45px rgba(55, 30, 44, 0.1);
  }

  .carte-fonctionnalite--moments {
    grid-column: 2;
  }

  .icone-fonctionnalite {
    width: 56px;
    height: 56px;
    margin-bottom: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--myhalal-primary);
    background: var(--myhalal-secondary);
    border-radius: 17px;
    font-size: 23px;
  }

  .carte-fonctionnalite h3 {
    margin: 0 0 12px;
    font-size: 20px;
  }

  .carte-fonctionnalite p {
    margin: 0;
    color: var(--myhalal-text);
    line-height: 1.7;
    font-size: 15px;
  }

  .section-securite {
    padding: 100px 0;
    background: #fff7fa;
  }

  .securite-contenu {
    display: grid;
    grid-template-columns: 0.9fr 1.1fr;
    align-items: center;
    gap: 90px;
  }

  .securite-illustration {
    min-height: 440px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .bouclier-principal {
    width: 260px;
    height: 260px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    background: linear-gradient(
      145deg,
      var(--myhalal-primary),
      var(--myhalal-primary-dark)
    );
    border-radius: 50%;
    box-shadow:
      0 30px 60px rgba(255, 95, 145, 0.25),
      0 0 0 35px rgba(255, 95, 145, 0.07);
  }

  .bouclier-principal svg {
    font-size: 100px;
  }

  .badge-securite {
    position: absolute;
    padding: 16px 20px;
    display: flex;
    align-items: center;
    gap: 10px;
    color: var(--myhalal-dark);
    background: white;
    border-radius: 15px;
    font-size: 14px;
    font-weight: 700;
    box-shadow: 0 16px 35px rgba(52, 26, 42, 0.12);
  }

  .badge-securite svg {
    color: var(--myhalal-primary);
  }

  .badge-un {
    top: 55px;
    right: 15px;
  }

  .badge-deux {
    bottom: 55px;
    left: 10px;
  }

  .securite-texte ul {
    margin: 25px 0 32px;
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .securite-texte li {
    display: flex;
    align-items: center;
    gap: 11px;
    color: var(--myhalal-text);
    font-size: 15px;
  }

  .securite-texte li svg {
    flex-shrink: 0;
    color: var(--myhalal-primary);
  }

  .temoignages-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 25px;
  }

  .carte-temoignage {
    padding: 32px;
    border: 1px solid var(--myhalal-border);
    border-radius: 22px;
    background: white;
  }

  .etoiles {
    display: flex;
    gap: 5px;
    margin-bottom: 18px;
    color: #f5b942;
  }

  .carte-temoignage p {
    min-height: 105px;
    color: var(--myhalal-text);
    font-size: 16px;
    line-height: 1.75;
  }

  .carte-temoignage strong {
    font-size: 14px;
  }

  .section-cta {
    padding: 70px 0;
  }

  .cta-contenu {
    padding: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 40px;
    color: white;
    background:
      radial-gradient(
        circle at 90% 0%,
        rgba(255, 255, 255, 0.2),
        transparent 35%
      ),
      linear-gradient(
        135deg,
        var(--myhalal-primary),
        var(--myhalal-primary-dark)
      );
    border-radius: 32px;
    box-shadow: 0 25px 55px rgba(255, 95, 145, 0.23);
  }

  .cta-contenu span {
    font-size: 14px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 1.2px;
  }

  .cta-contenu h2 {
    max-width: 680px;
    margin: 14px 0 10px;
    font-size: clamp(30px, 4vw, 44px);
    line-height: 1.15;
  }

  .cta-contenu p {
    margin: 0;
    opacity: 0.9;
    line-height: 1.7;
  }

  .cta-actions {
    min-width: 230px;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .bouton-cta-blanc,
  .bouton-cta-transparent {
    min-height: 52px;
    padding: 0 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 999px;
    text-decoration: none;
    font-size: 14px;
    font-weight: 800;
    transition: all 0.25s ease;
  }

  .bouton-cta-blanc {
    color: var(--myhalal-primary-dark);
    background: white;
  }

  .bouton-cta-transparent {
    color: white;
    border: 1px solid rgba(255, 255, 255, 0.55);
  }

  .bouton-cta-blanc:hover,
  .bouton-cta-transparent:hover {
    transform: translateY(-2px);
  }

  .landing-footer {
    padding-top: 65px;
    background: #24182c;
    color: white;
  }

  .footer-contenu {
    display: grid;
    grid-template-columns: 1.6fr repeat(3, 1fr);
    gap: 55px;
    padding-bottom: 55px;
  }

  .footer-marque {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 14px;
}

.footer-logo-circle {
  width: 84px;
  height: 84px;
  border-radius: 50%;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 2px solid #ff5f91;
}

.footer-logo-circle img {
  width: 68px;
  height: 68px;
  object-fit: contain;
}

  .footer-marque p {
    max-width: 320px;
    color: rgba(255, 255, 255, 0.68);
    line-height: 1.7;
    font-size: 14px;
  }

  .footer-colonne {
    display: flex;
    flex-direction: column;
    gap: 13px;
  }

  .footer-colonne h3 {
    margin: 0 0 10px;
    font-size: 16px;
  }

  .footer-colonne a {
    color: rgba(255, 255, 255, 0.68);
    text-decoration: none;
    font-size: 14px;
  }

  .footer-colonne a:hover {
    color: var(--myhalal-primary);
  }

  .footer-bas {
    padding: 22px 20px;
    text-align: center;
    color: rgba(255, 255, 255, 0.58);
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    font-size: 13px;
  }

  @media (max-width: 1000px) {
    .landing-nav {
      display: none;
    }

    .hero-contenu,
    .securite-contenu {
      grid-template-columns: 1fr;
    }

    .hero-texte {
      text-align: center;
    }

    .hero-description {
      margin-left: auto;
      margin-right: auto;
    }

    .hero-actions,
    .hero-garanties {
      justify-content: center;
    }

    .hero-visuel {
      margin-top: 15px;
    }

    .fonctionnalites-grid {
      grid-template-columns: repeat(2, 1fr);
    }

    .carte-fonctionnalite--moments {
      grid-column: 1 / -1;
      width: min(100%, 420px);
      justify-self: center;
    }

    .securite-contenu {
      gap: 40px;
    }

    .securite-texte {
      text-align: center;
    }

    .securite-texte ul {
      max-width: 520px;
      margin-left: auto;
      margin-right: auto;
      text-align: left;
    }

    .temoignages-grid {
      grid-template-columns: 1fr;
    }

    .carte-temoignage p {
      min-height: auto;
    }

    .cta-contenu {
      flex-direction: column;
      text-align: center;
    }

    .cta-actions {
      width: min(100%, 360px);
    }

    .footer-contenu {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (max-width: 700px) {
    .landing-container {
      width: min(100% - 28px, 1180px);
    }

    .navigation {
      min-height: 68px;
      gap: 10px;
    }

    .landing-logo img {
      height: 46px;
    }

    .bouton-login-header {
      display: none;
    }

    .bouton-inscription-header {
      min-height: 40px;
      padding: 0 14px;
    }

    .language-switcher button {
      width: 34px;
      height: 32px;
    }

    .hero-myhalal {
      padding: 55px 0 65px;
    }

    .hero-contenu {
      gap: 35px;
    }

    .hero-texte h1 {
      margin-top: 20px;
      font-size: 43px;
      letter-spacing: -1.8px;
    }

    .hero-description {
      font-size: 17px;
    }

    .hero-actions {
      flex-direction: column;
    }

    .bouton-principal,
    .bouton-secondaire {
      width: 100%;
    }

    .hero-garanties {
      flex-direction: column;
      align-items: center;
    }

    .hero-visuel {
      min-height: 460px;
    }

    .hero-image-wrapper {
      height: 430px;
      width: 92%;
    }

    .carte-flottante {
      min-width: 190px;
      padding: 12px;
    }

    .carte-profils {
      left: -5px;
      top: 45px;
    }

    .carte-securite {
      right: -5px;
      bottom: 35px;
    }

    .statistiques-grid {
      grid-template-columns: repeat(2, 1fr);
    }

    .statistique {
      border-right: 0;
      border-bottom: 1px solid rgba(255, 255, 255, 0.22);
    }

    .section-fonctionnalites,
    .section-temoignages,
    .section-securite {
      padding: 75px 0;
    }

    .fonctionnalites-grid {
      grid-template-columns: 1fr;
    }

    .carte-fonctionnalite--moments {
      grid-column: auto;
      width: 100%;
      justify-self: stretch;
    }

    .carte-fonctionnalite {
      padding: 27px;
    }

    .securite-illustration {
      min-height: 370px;
    }

    .bouclier-principal {
      width: 200px;
      height: 200px;
    }

    .bouclier-principal svg {
      font-size: 75px;
    }

    .badge-un {
      top: 35px;
      right: 0;
    }

    .badge-deux {
      bottom: 35px;
      left: 0;
    }

    .cta-contenu {
      padding: 45px 24px;
      border-radius: 24px;
    }

    .footer-contenu {
      grid-template-columns: 1fr;
      gap: 35px;
    }
  }

  @media (max-width: 450px) {
    .hero-texte h1 {
      font-size: 37px;
    }

    .hero-visuel {
      min-height: 410px;
    }

    .hero-image-wrapper {
      height: 390px;
    }

    .carte-flottante {
      min-width: auto;
      max-width: 185px;
    }

    .carte-flottante > svg {
      width: 38px;
      height: 38px;
    }

    .carte-flottante strong {
      font-size: 12px;
    }

    .carte-flottante span {
      font-size: 10px;
    }
  }
`;

const Feature = ({ icon, title, text, className = "" }) => (
  <article
    className={`carte-fonctionnalite ${className}`.trim()}
  >
    <div className="icone-fonctionnalite">{icon}</div>
    <h3>{title}</h3>
    <p>{text}</p>
  </article>
);

const Testimonial = ({ text, user }) => (
  <article className="carte-temoignage">
    <div className="etoiles">
      <FaStar />
      <FaStar />
      <FaStar />
      <FaStar />
      <FaStar />
    </div>

    <p>“{text}”</p>
    <strong>{user}</strong>
  </article>
);

const LandingPage = () => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.classList.add("landing-page-html");
    document.body.classList.add("landing-page-body");

    return () => {
      document.documentElement.classList.remove("landing-page-html");
      document.body.classList.remove("landing-page-body");
    };
  }, []);

  useEffect(() => {
    const savedLanguage = localStorage.getItem("language");

    if (savedLanguage === "fr" || savedLanguage === "en") {
      i18n.changeLanguage(savedLanguage);
      return;
    }

    const browserLanguage =
      navigator.language ||
      navigator.userLanguage ||
      "en";

    const detectedLanguage = browserLanguage
      .toLowerCase()
      .startsWith("fr")
      ? "fr"
      : "en";

    i18n.changeLanguage(detectedLanguage);
    localStorage.setItem("language", detectedLanguage);
  }, [i18n]);

  const currentLanguage = i18n.language?.startsWith("fr")
    ? "fr"
    : "en";

  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
    localStorage.setItem("language", language);
  };

  return (
    <>
      <style>{styles}</style>

      <div className="landing-page">
        <header className="landing-header">
          <div className="landing-container navigation">
            <Link to="/" className="landing-logo">
              <img src={logo} alt="MyHalal" />
            </Link>

            <nav className="landing-nav">
              <a href="#fonctionnalites">{t("nav.features")}</a>
              <a href="#securite">{t("nav.security")}</a>
              <a href="#temoignages">{t("nav.testimonials")}</a>
            </nav>

            <div className="navigation-actions">
              <div className="language-switcher">
                <button
                  type="button"
                  className={
                    currentLanguage === "fr" ? "language-active" : ""
                  }
                  onClick={() => changeLanguage("fr")}
                >
                  FR
                </button>

                <button
                  type="button"
                  className={
                    currentLanguage === "en" ? "language-active" : ""
                  }
                  onClick={() => changeLanguage("en")}
                >
                  EN
                </button>
              </div>

              <Link to="/login" className="bouton-login-header">
                {t("cta.login")}
              </Link>

              <Link to="/register" className="bouton-inscription-header">
                {t("login.register")}
              </Link>
            </div>
          </div>
        </header>

        <main>
          <section className="hero-myhalal">
            <div className="landing-container hero-contenu">
              <div className="hero-texte">
                <div className="hero-badge">
                  <FaHeart />
                  {t("hero.badge")}
                </div>

                <h1>
                  {t("hero.title")}
                  <span> {t("hero.highlight")}</span>
                </h1>

                <p className="hero-description">
                  {t("hero.description")}
                </p>

                <div className="hero-actions">
                  <Link to="/register" className="bouton-principal">
                    {t("hero.createProfile")}
                    <FaHeart />
                  </Link>

                  <Link to="/login" className="bouton-secondaire">
                    {t("hero.haveAccount")}
                  </Link>
                </div>

                <div className="hero-garanties">
                  <span>
                    <FaCheckCircle />
                    {t("hero.freeRegistration")}
                  </span>

                  <span>
                    <FaCheckCircle />
                    {t("hero.secureProfiles")}
                  </span>

                  <span>
                    <FaCheckCircle />
                    {t("hero.privacy")}
                  </span>
                </div>
              </div>

              <div className="hero-visuel">
                <div className="cercle-decoration cercle-un" />
                <div className="cercle-decoration cercle-deux" />

                <div className="hero-image-wrapper">
                  <img
                    src={heroCouple}
                    alt={t("login.coupleAlt")}
                    className="hero-image"
                  />
                </div>

                <div className="carte-flottante carte-profils">
                  <FaUserFriends />

                  <div>
                    <strong>{t("hero.seriousProfiles")}</strong>
                    <span>{t("hero.marriageSearch")}</span>
                  </div>
                </div>

                <div className="carte-flottante carte-securite">
                  <FaShieldAlt />

                  <div>
                    <strong>{t("hero.secureEnvironment")}</strong>
                    <span>{t("hero.privacyMatters")}</span>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="section-statistiques">
            <div className="landing-container statistiques-grid">
              <div className="statistique">
                <strong>100%</strong>
                <span>{t("stats.marriage")}</span>
              </div>

              <div className="statistique">
                <strong>24/7</strong>
                <span>{t("stats.access")}</span>
              </div>

              <div className="statistique">
                <strong>Private</strong>
                <span>{t("stats.privacy")}</span>
              </div>

              <div className="statistique">
                <strong>Global</strong>
                <span>{t("stats.international")}</span>
              </div>
            </div>
          </section>

          <section
            id="fonctionnalites"
            className="section-fonctionnalites"
          >
            <div className="landing-container">
              <div className="titre-section">
                <span>{t("features.smallTitle")}</span>
                <h2>{t("features.title")}</h2>
                <p>{t("features.description")}</p>
              </div>

              <div className="fonctionnalites-grid">
                <Feature
                  icon={<FaHeart />}
                  title={t("features.compatibility.title")}
                  text={t("features.compatibility.text")}
                />

                <Feature
                  icon={<FaComments />}
                  title={t("features.chat.title")}
                  text={t("features.chat.text")}
                />

                <Feature
                  icon={<FaVideo />}
                  title={t("features.calls.title")}
                  text={t("features.calls.text")}
                />

                <Feature
                  icon={<FaLock />}
                  title={t("features.privacy.title")}
                  text={t("features.privacy.text")}
                />

                <Feature
                  icon={<FaShieldAlt />}
                  title={t("features.protected.title")}
                  text={t("features.protected.text")}
                />

                <Feature
                  icon={<FaUserFriends />}
                  title={t("features.international.title")}
                  text={t("features.international.text")}
                />

                <Feature
                  className="carte-fonctionnalite--moments"
                  icon={<FaPlayCircle />}
                  title={t("features.moments.title")}
                  text={t("features.moments.text")}
                />

                <Feature
                  icon={<FaBroadcastTower />}
                  title={t("features.live.title")}
                  text={t("features.live.text")}
                />

                <Feature
                  icon={<FaCoins />}
                  title={t("features.coins.title")}
                  text={t("features.coins.text")}
                />

                <Feature
                  icon={<FaGift />}
                  title={t("features.gifts.title")}
                  text={t("features.gifts.text")}
                />
              </div>
            </div>
          </section>

          <section id="securite" className="section-securite">
            <div className="landing-container securite-contenu">
              <div className="securite-illustration">
                <div className="bouclier-principal">
                  <FaShieldAlt />
                </div>

                <div className="badge-securite badge-un">
                  <FaCheckCircle />
                  {t("security.profileControl")}
                </div>

                <div className="badge-securite badge-deux">
                  <FaLock />
                  {t("security.protectedData")}
                </div>
              </div>

              <div className="securite-texte">
                <span className="petit-titre">
                  {t("security.smallTitle")}
                </span>

                <h2>{t("security.title")}</h2>

                <p>{t("security.description")}</p>

                <ul>
                  <li>
                    <FaCheckCircle />
                    {t("security.block")}
                  </li>

                  <li>
                    <FaCheckCircle />
                    {t("security.photos")}
                  </li>

                  <li>
                    <FaCheckCircle />
                    {t("security.search")}
                  </li>

                  <li>
                    <FaCheckCircle />
                    {t("security.privateChat")}
                  </li>

                  <li>
                    <FaCheckCircle />
                    {t("security.verifyProfile")}
                  </li>

                  <li>
                    <FaCheckCircle />
                    {t("security.videoCall")}
                  </li>

                  <li>
                    <FaCheckCircle />
                    {t("security.neverSendMoney")}
                  </li>

                  <li>
                    <FaCheckCircle />
                    {t("security.publicMeeting")}
                  </li>
                </ul>

                <Link to="/register" className="bouton-principal">
                  {t("security.start")}
                </Link>
              </div>
            </div>
          </section>

          <section id="temoignages" className="section-temoignages">
            <div className="landing-container">
              <div className="titre-section">
                <span>{t("testimonials.smallTitle")}</span>
                <h2>{t("testimonials.title")}</h2>
              </div>

              <div className="temoignages-grid">
                <Testimonial
                  text={t("testimonials.first")}
                  user={t("testimonials.user")}
                />

                <Testimonial
                  text={t("testimonials.second")}
                  user={t("testimonials.user")}
                />

                <Testimonial
                  text={t("testimonials.third")}
                  user={t("testimonials.user")}
                />
              </div>
            </div>
          </section>

          <section className="section-cta">
            <div className="landing-container cta-contenu">
              <div>
                <span>{t("cta.smallTitle")}</span>
                <h2>{t("cta.title")}</h2>
                <p>{t("cta.description")}</p>
              </div>

              <div className="cta-actions">
                <Link to="/register" className="bouton-cta-blanc">
                  {t("cta.register")}
                </Link>

                <Link to="/login" className="bouton-cta-transparent">
                  {t("cta.login")}
                </Link>
              </div>
            </div>
          </section>
        </main>

        <footer className="landing-footer">
          <div className="landing-container footer-contenu">
            <div className="footer-marque">
              <div className="footer-logo-circle">
                <img src={logo1} alt="MyHalal" />
              </div>
              <p>{t("footer.description")}</p>
            </div>

            <div className="footer-colonne">
              <h3>MyHalal</h3>
              <a href="#fonctionnalites">{t("nav.features")}</a>
              <a href="#securite">{t("nav.security")}</a>
              <a href="#temoignages">{t("nav.testimonials")}</a>
            </div>

            <div className="footer-colonne">
              <h3>{t("footer.account")}</h3>
              <Link to="/login">{t("cta.login")}</Link>
              <Link to="/register">{t("footer.createAccount")}</Link>
            </div>

            <div className="footer-colonne">
              <h3>{t("footer.information")}</h3>
              <Link to="/privacy">{t("footer.privacy")}</Link>
              <Link to="/terms">{t("footer.terms")}</Link>
            </div>
          </div>

          <div className="footer-bas">
            © {new Date().getFullYear()} MyHalal. {t("footer.rights")}
          </div>
        </footer>
      </div>
    </>
  );
};

export default LandingPage;